import { combineReducers } from 'redux'
import auth from './auth'
import person from './person'
import invoice from './invoice'
import account from './account'

export const rootReducer = combineReducers({ auth, person, invoice, account })


export type RootState = ReturnType<typeof rootReducer>